// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"699da1bc","206":"ee7da08b","559":"ee7da08b"}[chunkId] + ".chunk.css";
};